import type { FC, PropsWithChildren, ReactNode } from 'react'

import { Form, type FormItemProps, type FormProps } from 'antd'
import cn from 'classnames'

import { AppTextArea } from '@web/shared/components/app-text-area'

import styles from './app-form.module.css'

type TProps = FormItemProps & {
  fontWeight?: number
  withoutBorder?: boolean
}

type TTextAreaProps = {
  name: string
  className?: string
  placeholder?: string
  isUpdating?: boolean
  minRows?: number
}

const Item: FC<PropsWithChildren<TProps>> = ({
  fontWeight = 700,
  withoutBorder,
  children,
  ...props
}) => (
  <Form.Item
    {...props}
    className={cn(styles['form-item'], {
      [styles.withoutBorder]: withoutBorder
    })}
    style={{ fontWeight: fontWeight }}
  >
    {children}
  </Form.Item>
)

// TODO: вынести text-area в отдельный компонент
const InputTextArea: FC<TTextAreaProps> = ({
  name,
  placeholder,
  isUpdating,
  className,
  minRows
}) => (
  <Form.Item name={name} className={className}>
    <AppTextArea
      placeholder={placeholder}
      disabled={isUpdating}
      minRows={minRows}
    />
  </Form.Item>
)

type TAppFormProps = FormProps & {
  children: ReactNode
  orientation?: 'vertical' | 'horizontal'
}

const AppForm = ({
  children,
  className,
  orientation,
  ...props
}: TAppFormProps) => (
  <Form
    {...props}
    className={cn(styles['form'], className, {
      [styles.horizontal]: orientation === 'horizontal'
    })}
  >
    {children}
  </Form>
)

AppForm.Item = Item
AppForm.TextArea = InputTextArea

export { AppForm }
